module.exports = __webpack_public_path__ + "img/yasemin-erdem.c1de2b62.jpg";